<!-- Revised on 2024/11/24 by mnavarro -->
<template>
  <Button v-if="enableReload" class="ms-2" size="xs" color="primary" :title="$t('key_reloadbutton_title')" variant="outline" @click="click()">
    <span>
      <i class="fa-solid fa-sync" aria-hidden="true"></i>
    </span>
  </Button>
</template>

<script>

  import Button from "./Button.vue";

  export default {
    name: "ReloadButton",
    components: {
      Button
    },
    props: {
      enableReload: {
        type: Boolean,
        default: true
      },
    },
    emits: ['change'],
    methods: {
      click() {
        this.$emit('change');
      }
    }
  };

</script>